import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Grid } from 'react-bootstrap';
import { bpOrderOperations, bpOrderSelectors } from "./state";
import ModuleHeader from '../../components/ModuleHeader';
import TableTemplate from '../../components/TableTemplate';
import BPOrderModal from './BPOrderModal';
import BPOrderButtons from './BPOrderButtons';
import BPOrderProposalModal from './BPOrderProposalModal';
import { orderShopsOperations } from "../BPOrderShops/state";
import { EMPTY_COUNT, DEFAULT_PAGE_NUM, ORDER_ALL, ORDER_TABLE, ORDER_CLOSED, FIELD_DEADLINE, FILE_CSV, FILE_XLSX, FIRST_INDEX, FIELD_CHECKBOX_INDETERMINATE, EMPTY_STRING, MIN_DB_DATE_EXACT, MAX_DB_DATE_EXACT, FIELD_STARTDATE, FIELD_ENDDATE, DASHED_DATE_FORMAT } from '../../../utils/constants';
import { ORDER_SHOPS, ORDER_UPLOAD } from './routes';
import configureStore from '../../../store/store';
import * as Actions from "./state/actions";
import view from '../../../includes/img/viewdetails.svg';
import $ from "jquery";
import { isNullOrUndefined } from 'util';
import moment from 'moment';

class BpOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: props.pageSize,
            page: this.props.page,
            toggleModal: false,
            proposalModal: false,
            checkboxItems: [],
            processing: this.props.processing,
            proposalId: this.props.proposalId,
            proposalName: this.props.proposalName,
            businessPartnerCode: this.props.riyoKigyoId,
            filterStartDate: moment(this.props.filterStartDate),
            filterEndDate: moment(this.props.filterEndDate),
            setModal: this.toggleModal.bind(this),
            setProposal: this.setProposal.bind(this),
            filterProcessing: this.filterProcessing,
            errors: []
        };

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.searchProposal = this.searchProposal.bind(this);
        this.orderShops = this.orderShops.bind(this);
    }

    componentWillMount() {
        if(undefined !== this.props.path && EMPTY_COUNT <= this.props.path.indexOf(this.props.location.pathname)){
            this.props.fetchDefault(this.state.size, this.state.page, this.state);
        }else{
            this.props.fetchDefault(this.state.size, DEFAULT_PAGE_NUM, this.state);
        }
        
    }

    setRowLines = (rows) => {
        this.setCheckboxIndeterminate(false);
        this.setState({ size: rows, page: DEFAULT_PAGE_NUM, checkboxItems: [] });
        this.props.fetchDefault(rows, DEFAULT_PAGE_NUM, this.state);
    }

    nextPage = () => {
        this.setCheckboxIndeterminate(false);
        this.props.fetchDefault(this.state.size, this.state.page + DEFAULT_PAGE_NUM, this.state);
        this.setState({ page: this.state.page + DEFAULT_PAGE_NUM, checkboxItems: [] });
    }

    prevPage = () => {
        this.setCheckboxIndeterminate(false);
        this.props.fetchDefault(this.state.size, this.state.page - DEFAULT_PAGE_NUM, this.state);
        this.setState({ page: this.state.page - DEFAULT_PAGE_NUM, checkboxItems: [] });
    }

    handleCheckboxChange = (event) => {
        this.setState({
            [event.target.name]:
                EMPTY_COUNT <= this.state[event.target.name].indexOf(event.target.value)
                    ? this.state[event.target.name].filter(arr => arr !== event.target.value)
                    : [...this.state[event.target.name], event.target.value]
        }, () => {
            let hasSelected = EMPTY_COUNT < this.state.checkboxItems.length && this.props.tableList.length > this.state.checkboxItems.length;

            if (hasSelected) {
                this.setCheckboxIndeterminate(true);
            } else {
                this.setCheckboxIndeterminate(false);
            }
        });
    }

    handleMainCheckboxChange = (hasSelected) => {
        if (hasSelected) {
            this.setState({ checkboxItems: [] });
        } else {
            let newCheckboxItems = this.props.tableList.map((data) => (
                data.proposalId + "♦" + data.closingDateTime + "♦" + data.proposalName + "♦" + data.deliveryDate + "♦" + data.shipping)
            );
            this.setState({ checkboxItems: newCheckboxItems });
        }
    }

    setCheckboxIndeterminate(flag) {
        let checkbox = $(`#${FIELD_CHECKBOX_INDETERMINATE}`)[FIRST_INDEX];
        checkbox.indeterminate = flag;
    }

    filterProcessing = (processing) => {
        this.setCheckboxIndeterminate(false);
        this.setState({ processing: processing, checkboxItems: [] },
            function () {
                this.props.fetchDefault(this.state.size, this.state.page, this.state);
            }
        )
    }

    handleDateChange = (name, customFormat, date) => {
        if (!isNullOrUndefined(date)) {
            let formatDate = date.format(customFormat)
            this.setState({ [name]: formatDate })
        }
    }

    toggleModal = () => {
        this.setState({
            startDate: this.state.filterStartDate,
            endDate: this.state.filterEndDate,
            toggleModal: !this.state.toggleModal,
            errors: []
        })
    }

    handleSubmit = () => {
        let errorList  = bpOrderSelectors.validateDates(this.state);

        if (EMPTY_COUNT < errorList.length) {
            this.setState({ errors: errorList });
        }else{
            this.setCheckboxIndeterminate(false);
            this.setState({
                filterStartDate: moment(this.state.startDate).format(DASHED_DATE_FORMAT),
                filterEndDate: moment(this.state.endDate).format(DASHED_DATE_FORMAT),
                toggleModal: !this.state.toggleModal,
                checkboxItems: [],
                error: []
            },
                function () {
                    this.props.fetchDefault(this.state.size, this.state.page, this.state);
                }
            )   
        }
    }

    setProposal = () => {
        this.setState({
            proposalModal: !this.state.proposalModal
        })
        configureStore().dispatch(Actions.allProposal([]));
    }

    searchProposal = (proposal) => {
        this.setCheckboxIndeterminate(false);
        let proposalId = (proposal.proposalName.includes(ORDER_ALL))
            ? proposal.proposalName : proposal.proposalId
        this.setState({
            proposalId: proposalId,
            proposalName: proposal.proposalName,
            proposalModal: !this.state.proposalModal,
            checkboxItems: []
        },
            function () {
                this.props.fetchDefault(this.state.size, this.state.page, this.state);
            }
        )
    }

    download = (fileType) => {
        this.props.download({
            fileType: fileType,
            items: this.state.checkboxItems,
            loginId: this.props.loginId
        })
    }

    orderShops = (data) => {
        this.props.history.push({
            pathname: ORDER_SHOPS,
            state: {
                proposal:
                {
                    proposalId: data.proposalId,
                    proposalName: data.proposalName,
                    orderDate: data.closingDate,
                    orderTime: data.closingTime,
                    orderDttm: data.closingDateTime,
                    deliveryDttm: data.deliveryDate,
                    deadline: data.deadline,
                    closingDateTime: data.closingDateTime 
                }
            }
        });
    }

    uploadButton() {
        return (
            <Button className="button-filter" onClick={() => this.props.history.push(ORDER_UPLOAD)}>受注データアップロード</Button>
        )
    }

    handleDateChangeRaw = (event) => {
        if (EMPTY_STRING !== event.target.value) {
            this.setState({ [event.target.name]: event.target.value })
        } else if (FIELD_STARTDATE === event.target.name) {
            this.setState({ [event.target.name]: MIN_DB_DATE_EXACT })
        } else if (FIELD_ENDDATE === event.target.name) {
            this.setState({ [event.target.name]: MAX_DB_DATE_EXACT })
        }
    }

    render() {
        return (
            <Grid fluid={true}>

                <Grid>
                    <ModuleHeader
                        title={"受注状況一覧"}
                        size={this.state.size}
                        filter={true}
                        setRowLines={this.setRowLines.bind(this)}
                        nextPage={this.nextPage}
                        prevPage={this.prevPage}
                        maxPage={this.props.pageCount}
                        currPage={this.state.page}
                        titleAction={<BPOrderButtons {...this.state} />}
                        withAction={this.uploadButton()}
                        order={true}
                    />

                    <TableTemplate
                        {...this.props}
                        tableName={ORDER_TABLE}
                        checkboxItems={this.state.checkboxItems}
                        handleCheckboxChange={this.handleCheckboxChange}
                        handleMainCheckboxChange={this.handleMainCheckboxChange}
                        specialRow={{ field: FIELD_DEADLINE, value: ORDER_CLOSED, color: "#ccc" }}
                        rowButtons={[
                            {
                                onClick: this.orderShops,
                                img: view,
                                bsStyle: "link"
                            }
                        ]}
                    />
                    <br />
                    <center>
                        <Button
                            className="button-filter pagination"
                            onClick={() => this.download(FILE_CSV)}
                            disabled={EMPTY_COUNT === this.state.checkboxItems.length}
                        >
                            CSVデータダウンロード
                        </Button>
                        <Button
                            className="button-filter pagination"
                            onClick={() => this.download(FILE_XLSX)}
                            disabled={EMPTY_COUNT === this.state.checkboxItems.length}
                        >
                            受注帳票Excelダウンロード
                        </Button>
                    </center>

                    <BPOrderModal
                        title={"発注締日期間指定"}
                        showModal={this.state.toggleModal}
                        toggleModal={this.toggleModal}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        filterStartDate={this.props.filterStartDate}
                        filterEndDate={this.props.filterEndDate}
                        handleDateChange={this.handleDateChange}
                        handleSubmit={this.handleSubmit}
                        handleDateChangeRaw={this.handleDateChangeRaw}
                        errors={this.state.errors}
                    />

                    <BPOrderProposalModal
                        title={"商品提案グループ指定"}
                        showModal={this.state.proposalModal}
                        toggleModal={this.setProposal}
                        searchProposal={this.searchProposal}
                    />
                </Grid>

            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        tableHeader: state.bpOrder.tableHeader,
        tableColumns: state.bpOrder.tableColumns,
        tableList: state.bpOrder.list,
        pageSize: state.bpOrder.pageSize,
        pageCount: state.bpOrder.pageCount,
        riyoKigyoId: state.auth.credentials.riyo_kigyo_id,
        loginId: state.auth.credentials.loginId,
        page: state.bpOrder.page,
        path: state.bpOrder.path,
        filterStartDate: state.bpOrder.filterStartDate,
        filterEndDate: state.bpOrder.filterEndDate,
        processing: state.bpOrder.processing,
        proposalId: state.bpOrder.proposalId,
        proposalName: state.bpOrder.proposalName,
    }
};

const mapDispatchToProps = {
    fetchDefault: bpOrderOperations.fetchDefault,
    fetchShops: orderShopsOperations.fetchDefault,
    download: bpOrderOperations.downloadFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(BpOrder);